import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const heroSlider = document.getElementById("hero_redex_slider-js");

  if (heroSlider) {
    const main = new Splide(heroSlider, {
      type: "loop",
      perPage: 1,
      pagination: true,
      arrows: false,
      autoplay: true,
      interval: 5000,
    });

    main.mount();
  }
});
